/**
 * Handlers named get...Cached are called with GET and their request serialized into the query string
 * so their responses can be cached by url (see Handler.cachePolicy)
 */
export function isCachedHandler(handlerName: string) {
    return handlerName.startsWith("get") && handlerName.endsWith("Cached");
}

/**
 * Serializes the request into a query string, keys are sorted so the same payload always produces
 * the same url (and so the same cache entry), undefined values are omitted (same as JSON.stringify)
 */
export function serializeRequest<Request>(request: Request): string {
    const queryParams = new URLSearchParams();
    Object.entries(request ?? {})
        .filter(([, value]) => value !== undefined)
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .forEach(([key, value]) => {
            queryParams.set(key, JSON.stringify(value));
        });
    return queryParams.toString();
}

/**
 * Restores the request from the parsed query (as express exposes it in req.query), throws
 * if any of the values isn't a valid serialized value
 */
export function deserializeRequest<Request>(query: Record<string, unknown>): Request {
    const request = {} as Request;
    Object.entries(query ?? {}).forEach(([key, value]) => {
        if (typeof value !== "string") {
            throw new Error(`Invalid query param "${key}"`);
        }
        request[key] = JSON.parse(value);
    });
    return request;
}
